import React from 'react';
import { SelectContainer } from './Select.styled';
import BaselineKeyboardArrowDown24 from 'src/assets/images/BaselineKeyboardArrowDown24.svg';
import SortAscending from 'src/assets/images/SortAscending.svg';

export default function Select({
    isFromConsignmentAddProductGuide,
    filter = false,
    width = '100%',
    sortIcon = SortAscending,
    consignmentBilling = false,
    consignmentAdd = false,
    height = '40px',
    smWidth = '',
    marginLeft = '0px',
    xSmWidth = '',
    value = null,
    options = [],
    className = '',
    borderColor = '#0000003b',
    onChange = () => {},
    onInputChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    optionLabel = '',
    optionValue = '',
    placeholder = '',
    itemTemplate = null,
    style = {},
    disabled = false,
    borderRadius = '',
    valueTemplate = null,
    emptyMessage = '',
    labelColor = '',
    selectedLabelFontSize = '',
    selectedLabelfontFamily = '',
    showClear = '',
    hideClear=false,
    scrollHeight,
    onOpen = () => {},
    onClose = () => {}, // Added onClose prop for handling close event
    editable = false,	
    crossIconMargin = '',
    id = '',
    right = '',
    marginRight = '',
    mbMarginBottom = '',
    ipadMarginLeft='',
    iPadwidth= '',
    mbBorderRadius = '',
    sortMarginRight = '',
    isSortMobileView = false,
    name = '', // Added name prop to handle specific behavior
    isFromProcedure = false, // Added isFromProcedure prop to handle specific behavior
    mbMarginRight,
    panelClassName = '',
}) {
    const handleChange = (event) => {
        const key = event?.originalEvent?.key;

        if (name) {
            onChange({ [name]: event.value });
        } else if (isFromProcedure && (key === 'ArrowDown' || key === 'ArrowUp')) {
            onChange(event.value, true);
        } else {
            onChange(event.value);
        }
    };

    const handleHide = () => {
        if (value && isFromProcedure) {
            onChange?.(value);
        }
        onClose?.();
    };

    const isValueValid = () => {
        if (!value || !options || options.length === 0) {
            return false;
        }
        if (optionValue) {
            return options.some(option => option[optionValue] === value);
        }        
        return options.some(option => option === value);
    };

    return (
        <>
            <SelectContainer
                isFromConsignmentAddProductGuide={isFromConsignmentAddProductGuide}
                filter={filter}
                width={width}
                sortIcon={sortIcon}
                consignmentBilling={consignmentBilling}
                consignmentAdd={consignmentAdd}
                height={height}
                smWidth={smWidth}
                marginLeft={marginLeft}
                xSmWidth={xSmWidth}
                value={value}
                options={options}
                className={className}
                borderColor={borderColor}
                onChange={handleChange}
                onInputChange={(event) => onInputChange(event.value)}
                onFocus={onFocus}
                onBlur={onBlur}
                optionLabel={optionLabel}
                optionValue={optionValue}
                placeholder={placeholder}
                itemTemplate={itemTemplate}
                style={style}
                disabled={disabled}
                borderRadius={borderRadius}
                valueTemplate={valueTemplate}
                emptyMessage={emptyMessage}
                labelColor={labelColor}
                downArrowIcon={BaselineKeyboardArrowDown24}
                selectedLabelFontSize={selectedLabelFontSize}
                selectedLabelfontFamily={selectedLabelfontFamily}
                showClear={!hideClear && isValueValid() ? value : false}
                scrollHeight={scrollHeight}
                onShow={onOpen || (() => {})}
                onHide={handleHide}
                editable={editable}
                crossIconMargin={crossIconMargin}
                id={id}
                right={right}
                marginRight={marginRight}
                mbMarginBottom={mbMarginBottom}
                ipadMarginLeft={ipadMarginLeft}
                iPadwidth={iPadwidth}
                mbBorderRadius={mbBorderRadius}
                sortMarginRight={sortMarginRight}
                isSortMobileView={isSortMobileView}
                mbMarginRight={mbMarginRight}
                panelClassName={panelClassName}  
            />
        </>
    );
}